// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__LqSWQ","balanceDisclaimer":"posDashboard_balanceDisclaimer__1Ads1"};